import React, { useEffect, useState } from "react";

import moment from "moment";

import useFAST from "../../../contexts/FASTContext";

import type { JSX } from "react";

export default function ChannelClock(): JSX.Element {
  const { state } = useFAST();
  const timezoneChannel = state.channelData?.timezone;
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const timeInTimezone = new Date(
    currentTime.toLocaleString("en-US", { timeZone: timezoneChannel }),
  );
  const formattedTime = moment(timeInTimezone).format("HH:mm:ss");

  return (
    <div className="border-border bg-card flex flex-col items-center rounded-[0.46875rem] border p-[0.3125rem] font-normal">
      <span className="font-family-digital -mb-2 text-center text-4xl">
        {formattedTime}
      </span>
      <span className="text-[0.703125rem]">{timezoneChannel}</span>
    </div>
  );
}
